/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_LabelInputs */

const en_svc_integration_label = /** @type {(inputs: Svc_Integration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI integration`)
};

const lv_svc_integration_label = /** @type {(inputs: Svc_Integration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI integrācija`)
};

/**
* | output |
* | --- |
* | "AI integration" |
*
* @param {Svc_Integration_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_label = /** @type {((inputs?: Svc_Integration_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_label(inputs)
	return en_svc_integration_label(inputs)
});